import { Component, OnInit } from '@angular/core';
import {NavigationService} from '../../services/navigation.service';
import {} from '../../services/alert.service';
@Component({
  selector: 'app-custom-date',
  templateUrl: './custome-date-picker.component.html',
  styleUrls: ['./custome-date-picker.component.scss']
})
export class CustomDateComponent implements OnInit {

  constructor(private navigationService: NavigationService) { }

  ngOnInit(): void {
  }

  back() {
    this.navigationService.back();
  }
}
